export const nativeMessageTypes = {
  login: 'login',
  logout: 'logout',
  goToStudentMode: 'goToStudentMode',
  goToFacilitatorMode: 'goToFacilitatorMode',
  goToAdminMode: 'goToAdminMode',
  finishedLoading: 'finishedLoading',
  readyForLogin: 'readyForLogin',
  reloadUser: 'reloadUser',
  updateDailyBeats: 'updateDailyBeats',
  resetStudentMode: 'resetStudentMode',
  playVideo: 'playVideo',
  ssoCode: 'ssoCode',
} as const
